module.exports = __webpack_public_path__ + "assets/img/driver-btn-ad8e494a.png";